"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptimisticAsyncObservable = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var mergeAll_1 = __importDefault(require("lodash/fp/mergeAll"));
var _1 = require(".");
var EqualityComparers_1 = require("../EqualityComparers");
var ObservableMutationView_1 = require("./ObservableMutationView");
var OptimisticAsyncObservable = /** @class */ (function () {
    function OptimisticAsyncObservable(baseValue) {
        var _this = this;
        this._baseValue = new _1.Observable(baseValue);
        this._mutationView = new ObservableMutationView_1.ObservableMutationView();
        this._composedValue = new _1.ComputedObservable(function () {
            // TODO: Ensure this is never actually null
            return !_this._baseValue.value
                ? null
                : (0, mergeAll_1.default)([_this._baseValue.value, _this._mutationView.value]);
        }, [this._baseValue, this._mutationView], EqualityComparers_1.deepEqualityComparer);
    }
    OptimisticAsyncObservable.prototype.update = function (optimisticUpdate, updater) {
        var mutationHandle = this._mutationView.mutate(optimisticUpdate);
        return new Promise(function (resolve) {
            var completedOrCancelled = function () {
                mutationHandle.dispose();
                resolve();
            };
            updater(completedOrCancelled).then(completedOrCancelled, completedOrCancelled);
        });
    };
    Object.defineProperty(OptimisticAsyncObservable.prototype, "value", {
        get: function () {
            return this._composedValue.value;
        },
        enumerable: false,
        configurable: true
    });
    OptimisticAsyncObservable.prototype.setBaseValue = function (baseValue) {
        this._baseValue.value = baseValue;
    };
    OptimisticAsyncObservable.prototype.subscribe = function (handler) {
        return this._composedValue.subscribe(handler);
    };
    OptimisticAsyncObservable.prototype.dispose = function () {
        this._composedValue.dispose();
        this._mutationView.dispose();
        this._baseValue.dispose();
    };
    return OptimisticAsyncObservable;
}());
exports.OptimisticAsyncObservable = OptimisticAsyncObservable;
//# sourceMappingURL=OptimisticAsyncObservable.js.map